import React from "react";
import { FiMinus as FiMinusIcon, FiPlus as FiPlusIcon } from "react-icons/fi";
import { useContentScale } from "../../context/contentScale/ContentScaleContext";

const FiMinus = FiMinusIcon as React.FC<any>;
const FiPlus = FiPlusIcon as React.FC<any>;

// Scales only the main content pane (see MainLayout.tsx) -- the sidebar and
// this header stay at their own fixed size regardless of this control.
const ContentZoomControl = () => {
  const { scale, increase, decrease, reset, canIncrease, canDecrease } =
    useContentScale();

  return (
    <div
      className="content-zoom-control"
      role="group"
      aria-label="Page content size"
    >
      <button
        type="button"
        onClick={decrease}
        disabled={!canDecrease}
        aria-label="Decrease page content size"
        title="Decrease page content size"
      >
        <FiMinus />
      </button>
      <span
        className="content-zoom-control__value"
        role="button"
        tabIndex={0}
        onClick={reset}
        title="Reset to 100%"
      >
        {scale}%
      </span>
      <button
        type="button"
        onClick={increase}
        disabled={!canIncrease}
        aria-label="Increase page content size"
        title="Increase page content size"
      >
        <FiPlus />
      </button>
    </div>
  );
};

export default ContentZoomControl;
